//@flow

import React, { Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';
import capitalize from 'lodash/capitalize';

import Room from './Room';
import type { Lodge } from '../helpers';
import { WhitePanel } from '../../../components';
import { getFromCookies, getDiffInDays } from '../helpers';


const getRoomWithPrices = (rooms, mealPlan) =>
  //eslint-disable-next-line
  rooms.filter(rT => {
    for (let room in mealPlan) {
      const priceAvailableForRoom = mealPlan[room];
      const roomHasDescription = room === rT.roomType.toLowerCase();

      if (roomHasDescription && priceAvailableForRoom) return rT;
    }
  });

const getInclusions = (services, type) => services[type].map(capitalize).filter(x => x);
const getServiceDetails = (services, key) => {
  return services.filter(val => val.name && val.name.toLowerCase() === key)[0] || { rate: { amount: 0 } };
};
 
type Props = {
  isAddedToCart: boolean,
  setIsAddedToCart: (boolean) => void,
  lodgeDetail: Lodge,
  openModal: () => void,
}

export default function ChooseRoomType(props: Props) {
  const { isAddedToCart, setIsAddedToCart, lodgeDetail, openModal } = props;
  const { rooms, mealPlan, includedServices, id, services } = lodgeDetail;
  const { pax, checkinDate, checkoutDate } = getFromCookies();

  const numberOfDays = getDiffInDays(checkinDate, checkoutDate);
  const roomsWithPrices = getRoomWithPrices(rooms, mealPlan);

  if (isEmpty(roomsWithPrices)) return null;

  return (
    <WhitePanel>
      <h2>CHOOSE YOUR ROOM</h2>
      {roomsWithPrices.map(r => {
        const { roomType, title, nonShareable, capacity } = r;
        const lowerCasedRoomType = roomType.toLowerCase();

        const inclusions: Array<string> = React.useMemo(() => { 
          return getInclusions(includedServices, lowerCasedRoomType);
        }, [includedServices, lowerCasedRoomType]); 

        const { currency, amount } = mealPlan[lowerCasedRoomType];
        let totalPrice: string = '0';
        const numRooms = Math.ceil(Number(pax) / (Number(capacity) || 1));
        if (nonShareable) {
          const { rate: { amount: breakfastRate } } = getServiceDetails(services, 'breakfast');
          const roomRate = (Number(amount) - Number(breakfastRate)) * capacity;
          totalPrice = (numRooms * roomRate) + (Number(breakfastRate) * Number(pax));
        } else {
          totalPrice = Number(amount) * Number(pax);
        }

        totalPrice = (totalPrice * Number(numberOfDays)).toLocaleString();

       return (
          <Room
           key={title}
           id={id}
           title={title}
           currency={currency}
           numRooms={numRooms}
           type={lowerCasedRoomType}
           totalPrice={totalPrice}
           inclusions={inclusions}
           numDays={numberOfDays}
           RoomNotes={RoomNotes}
           RoomChargeMessage={RoomChargeMessage}
           onSuccess={() => setIsAddedToCart(!isAddedToCart)}
           openModal={openModal}
          />
        );
      })}
    </WhitePanel>
  );
}

const RoomNotes = () => (
  <Fragment>
    <ul className="room_notes">
      <li>* Room Bookings are on a twin sharing basis.</li>
      <li>* Booking Date changes of +/-2 days will be accommodated by this lodge.</li>
    </ul>
    <ul className="room_plus_point">
      <li>
        <strong>Free 48 hours</strong> cancellation
      </li>
      <li>Good breakfast included</li>
    </ul>
    <div className="room_charge">
      <p>
        <strong>Includes all taxes</strong>
      </p>
    </div>
  </Fragment>
);

const RoomChargeMessage = () => (
  <Fragment>
    <div className="room_charge">
      <p>
        <strong>Includes all taxes</strong>
      </p>
    </div>
    <ul className="room_plus_point">
      <li>
        <strong>Free 48 hours</strong> cancellation
      </li>
    </ul>
  </Fragment>
);



// WEBPACK FOOTER //
// ./src/screens/Lodge/Details/ChooseRoomType.js